import { Link } from 'react-router-dom';

export function StoreFooter() {
  return (
    <footer className="bg-stone-900 text-stone-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">
              MEGA<span className="text-red-500">MART</span>
            </h3>
            <p className="text-sm">
              Your trusted online marketplace for quality products at affordable prices.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products" className="hover:text-white transition">All Products</Link></li>
              <li><Link to="/cart" className="hover:text-white transition">Shopping Cart</Link></li>
              <li><Link to="/orders" className="hover:text-white transition">Track Order</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-semibold text-white mb-4">Customer Service</h4>
            <ul className="space-y-2 text-sm">
              <li><span className="hover:text-white transition cursor-pointer">Contact Us</span></li>
              <li><span className="hover:text-white transition cursor-pointer">Shipping Info</span></li>
              <li><span className="hover:text-white transition cursor-pointer">Returns Policy</span></li>
               <li><Link to="/privacy-policy" className="hover:text-white transition cursor-pointer">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* Payment Methods */}
          <div>
            <h4 className="font-semibold text-white mb-4">Payment Methods</h4>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-green-600 rounded flex items-center justify-center text-white text-xs font-bold">
                  M
                </div>
                <span>M-Pesa</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 bg-stone-700 rounded flex items-center justify-center text-white text-xs">
                  COD
                </div>
                <span>Cash on Delivery</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-stone-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} MEGAMart. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
